document.addEventListener('alpine:init', () => {
  Alpine.store('bottomSheet', {
    visible: false,
    bgType: 'dark',
    mergeHeader: false,

    open(bgType = 'dark', mergeHeader = false) {
      this.visible = true;
      this.bgType = bgType;
      this.mergeHeader = mergeHeader;
    },

    close() {
      this.visible = false;
      window.dispatchEvent(new CustomEvent('close-bottom-sheet'));
      setTimeout(() => (this.mergeHeader = false), 400);
    },
  });
});